import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { Box, Paper } from "@mui/material";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const PlayerGroupedBarChart = ({ playerName = "", dataProp }) => {
  if (
    !dataProp ||
    !dataProp.labels ||
    !dataProp.player ||
    !dataProp.average ||
    !dataProp.ranks
  ) {
    return null;
  }

  const source = dataProp;

  const data = {
    labels: source.labels,
    datasets: [
      {
        label: playerName,
        data: source.player,
        backgroundColor: "rgba(186, 28, 28, 0.85)",
        borderRadius: 6,
        barPercentage: 0.8,
        categoryPercentage: 0.7,
      },
      {
        label: "Group Average",
        data: source.average,
        backgroundColor: "rgba(32, 66, 132, 0.85)",
        borderRadius: 6,
        barPercentage: 0.8,
        categoryPercentage: 0.7,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top",
        labels: {
          boxWidth: 12,
          padding: 15,
        },
      },
      title: {
        display: true,
        text: "Anthropometric Comparison",
        font: {
          size: 16,
          weight: "600",
        },
        padding: { bottom: 10 },
      },
      tooltip: {
        backgroundColor: "#1f2937",
        titleColor: "#fff",
        bodyColor: "#fff",
        padding: 10,
        callbacks: {
          afterTitle: (ctx) => {
            const index = ctx[0].dataIndex;
            return `Rank: ${source.ranks[index]}`;
          },
        },
      },
    },
    scales: {
      x: {
        grid: { display: false },
        ticks: {
          font: { size: 11 },
        },
      },
      y: {
        beginAtZero: true,
        grid: {
          color: "rgba(0,0,0,0.05)",
        },
        ticks: {
          font: { size: 11 },
        },
      },
    },
  };

  return (
    <Box sx={{ maxWidth: 900, width: "100%", mx: "auto" }}>
      <Paper
        sx={{
          padding: 2,
          backgroundColor: "#F9FAFB",
          borderRadius: "12px",
        }}
        elevation={2}
      >
        <Box sx={{ height: 380 }}>
          <Bar data={data} options={options} />
        </Box>

        <Box
          mt={1.5}
          display="flex"
          flexWrap="wrap"
          justifyContent="center"
          gap={1.2}
        >
          {source.labels.map((label, i) => {
            const rankText = source.ranks[i];

            return (
              <Box
                key={label}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 0.8,
                  px: 1.4,
                  py: 0.6,
                  borderRadius: "999px",
                  fontSize: "12px",
                  backgroundColor: "#f8fafc",
                  border: "1px solid #e5e7eb",
                  color: "#1f2937",
                  transition: "all 0.2s ease",
                  "&:hover": {
                    backgroundColor: "#eef2f7",
                    borderColor: "#d1d5db",
                    transform: "translateY(-1px)",
                  },
                }}
              >
                <span style={{ opacity: 0.7 }}>{label}</span>
                <span style={{ fontSize: "11px", opacity: 0.5 }}>→</span>
                <span
                  style={{
                    fontWeight: 600,
                    background: "#e2e8f0",
                    padding: "3px 8px",
                    borderRadius: "6px",
                    letterSpacing: "0.3px",
                  }}
                >
                  {rankText}
                </span>
              </Box>
            );
          })}
        </Box>
      </Paper>
    </Box>
  );
};

export default PlayerGroupedBarChart;
